// ProtectedRoute.js
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import LoadingScreen from "./pages/Loading"; // Adjust path if needed
import logger from './utils/logger';
import { isDevelopment } from './utils/env';
import { wasSignedOut } from './Authentication/sessionEnded';

// Grace window for auth state to stabilize (e.g. right after signup auto sign-in);
// bounded so an unauthenticated user is never stuck on an infinite spinner.
const AuthGrace = ({ ms = 8000 }) => {
  const [expired, setExpired] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setExpired(true), ms);
    return () => clearTimeout(t);
  }, [ms]);
  return expired ? <Navigate to="/signin" replace /> : <LoadingScreen />;
};

export const DevRoute = ({ children }) => {
  if (!isDevelopment()) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export const ProtectedRoute = ({ children }) => {
  const { signedIn, isLoading, isNewUser, isLoaded, sessionEnded } = useSelector((state) => state.loginUser);
  const hasIncompleteProfile = useSelector((state) => Boolean(state.profileData?.error));
  const location = useLocation();

  if (isLoading || !isLoaded) {
    return <LoadingScreen />;
  }

  // Allow preferences-quiz route to render while auth state stabilizes for new users. Not after a
  // sign-out in this tab: then there is no session coming, and Back sat on this spinner.
  if (!signedIn) {
    const sessionComing = !sessionEnded && !wasSignedOut();
    if (sessionComing && (location.pathname === "/dashboard/apply" || location.pathname === "/preferences-quiz")) {
      return <AuthGrace />;
    }
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if ((isNewUser || hasIncompleteProfile) && location.pathname !== "/preferences-quiz") {
    logger.log("Routes: Redirecting to preferences-quiz due to incomplete profile");
    return <Navigate to="/preferences-quiz" state={{ from: location }} replace />;
  }

  return children;
};